export default __webpack_public_path__ + "static/media/logo-capi-single.a974c13c.svg";